import { getApiClient, initializeApiClient } from "../../apiService";

export const AddOtherProjectSupport = async (
  organizationName,
  tE_OS_NatureOfSupportId,
  supportDetails,
  supportAmountIfMonetary,
  tE_TeamMembersPreviousExperiencePartnershipsId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TE_OS_OtherSupportingOrganizations/AddTE_OS_OtherSupportingOrganizationsData`,
    {
      organizationName: organizationName,
      tE_OS_NatureOfSupportId: tE_OS_NatureOfSupportId,
      supportDetails: supportDetails,
      supportAmountIfMonetary: supportAmountIfMonetary,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        tE_TeamMembersPreviousExperiencePartnershipsId,
    }
  );

  return response;
};

export default AddOtherProjectSupport;
